export const sizes = {
  md: 'md',
  sm: 'sm'
};
export const NAVBAR_ACCOUNT_WIDTH = '240px';